import Box from "@mui/material/Box";
import MuiCircularProgress from "@mui/material/CircularProgress";
import type { SxProps } from "@mui/material/styles";

interface CircularProgressProps {
  sx?: SxProps;
  size?: number | string;
}

export default function CircularProgress({ sx, size }: CircularProgressProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 5,
        ...sx
      }}
      className="animate__animated animate__fadeIn"
    >
      <MuiCircularProgress size={size} />
    </Box>
  );
}
